//const baseUrl = "http://192.168.168.57:8080/truckrepairshop/";
const baseUrl = "https://api.truckrepairshop.net/"

const BaseUrl={
    baseUrl
};

export default BaseUrl;